import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';

@Component({
    selector: 'shared-form-for-address',
    templateUrl: './form-for-address.shared.component.html',
    styleUrls: ['./form-for-address.shared.component.scss']
})
export class FormForAddressComponent extends FormTypesComponent implements OnInit {
    private _deliveryAddress: APICommon.IGooglePlaceDetails = null;

    @Output() public onSelected: EventEmitter<APICommon.IGooglePlaceDetails> = new EventEmitter();

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
    ) {
        super(config, formBuilder);
        this.formName = 'address-suggestion';
    }

    ngOnInit(): void {
        this.formControl = this.formBuilder.group({
            address: [
                {
                    value: '',
                    disabled: false
                },
                [
                    Validators.required,
                ]
            ],
        });

        this.formChangesListener$ = this.formControl.controls.address.valueChanges
            .subscribe(value => {
                if (this._deliveryAddress?.structured_formatting?.main_text !== value) {
                    this._deliveryAddress = null;

                    this.onSelected.emit(null);
                }
            });

        this.onInit.emit(this.formControl);
    }

    public handleFormSubmit($event: Event): void {
        const formValues = this.getFormValues();
        this.controllers.members.linkRewardsAccount(formValues.password);
    }

    public handleAddressSelectedClick($event: APICommon.IGooglePlaceDetails): void {
        this.formControl.get('address').setValue(($event?.structured_formatting?.main_text || $event?.description || '').trim());
        this._deliveryAddress = { ...$event };

        this.onSelected.emit(this._deliveryAddress);
    }

    public get deliveryFormDisabled(): boolean {
        return this._deliveryAddress === null;
    }

    public get isFormDisabled(): boolean {
        return this.formControl.controls.searchInput.errors !== null || this.deliveryFormDisabled;
    }
}
